export default __webpack_public_path__ + "static/media/The Classic Trio.6c9f5aec.png";